export const GET_STARTED = `/`;

// employer
export const EMPLOYER_INFORMATION = `/employer/company-information`;
export const EMPLOYER_ADD_A_PAYMENT_METHOD = `/employer/add-a-payment-method`;
export const EMPLOYER_COMPLETE_PROFILE = `/employer/company-profile`;

export const STUDENT_INFORMATION = `/student/personal-information`;
export const STUDENT_EDUCATIONAL_BACKGROUND = `/student/educational-background`;
export const STUDENT_COMPLETE_PROFILE = `/student/complete-profile`;
